import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const faqs = [
  {
    q: "Que comprend l'hébergement gratuit ?",
    a: "Tout : serveurs cloud rapides, certificat SSL, bande passante et maintenance technique, gérés à 100% par notre équipe. Vous n'avez aucune facture d'hébergement, aucun renouvellement à surveiller, aucun réglage technique à faire.",
  },
  {
    q: "Comment fonctionnent les 3 modifications par mois ?",
    a: "Changement de prix, ajout de photos de réalisations, ajustement d'offres ou de textes : envoyez simplement votre demande par courriel et nous l'appliquons, généralement sous 24 à 48h ouvrables. Inclus dans le forfait Croissance & Sérénité.",
  },
  {
    q: "Pourquoi choisir un abonnement plutôt qu'un paiement unique ?",
    a: "C'est moins risqué et ça préserve votre trésorerie : pas de chèque de 5 000 $ à sortir d'un coup. Et surtout, vous obtenez un technicien dédié qui maintient, sécurise et fait évoluer votre site en continu — sans payer de salaire.",
  },
  {
    q: "Comment fonctionne l'offre avec 4 mois gratuits ?",
    a: "En réglant l'année d'un coup, vous ne payez que 8 mois sur 12 : 800 $ pour l'Essentiel (au lieu de 1 300 $) ou 1 200 $ pour Croissance & Sérénité (au lieu de 1 950 $). Soit 33% d'économie, sans rien changer au service.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="font-mono-label mb-4">Chapitre 03 — Questions</p>
          <h2 className="text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
            Les réponses, <span className="text-emerald-400">sans détour</span>
          </h2>
        </Reveal>

        <div className="mt-12 space-y-4">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={item.q} delay={i * 0.08}>
                <div
                  className={`glass overflow-hidden rounded-2xl transition-colors duration-300 ${
                    isOpen ? "border-emerald-400/30" : ""
                  }`}
                >
                  <button
                    data-testid={`faq-question-${i}`}
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 p-6 text-left"
                  >
                    <span className="text-base font-semibold text-white">{item.q}</span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
                        isOpen ? "bg-emerald-500/20 text-emerald-300" : "bg-white/5 text-gray-400"
                      }`}
                    >
                      <Plus className="h-4 w-4" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          className="px-6 pb-6 text-sm leading-relaxed text-gray-400"
                          data-testid={`faq-answer-${i}`}
                        >
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
